<!-- Default layout (non–small companies) -->
<div class="bottom-buttons" *ngIf="!isSmallCompany && billingMode !== 'invoicing'">
  <!-- Learn More raised (UAR variant) -->
  <a mat-raised-button color="primary" target="_blank" class="learn-more-button" [href]="learnMoreUrl"
    *ngIf="upsellButtons?.showLearnMoreBtn && !isLargeCompany"
    [trackClick]="{ page: 'Learn More Button Clicked', location: trackLocation }">
    {{ learnMoreLabel | uppercase }}
  </a>

  <!-- Learn More stroked -->
  <a mat-stroked-button color="primary" target="_blank" class="learn-more-button" [href]="learnMoreUrl"
    *ngIf="upsellButtons?.showLearnMoreStrokedBtn && !isLargeCompany"
    [trackClick]="{ page: 'Learn More Button Clicked', location: trackLocation }">
    {{ learnMoreLabel | uppercase }}
  </a>

  <!-- Contact Sales when Buy Now is visible: stroked and uppercase -->
  <a mat-stroked-button color="primary" class="learn-more-button upgrade-btn"
    *ngIf="upsellButtons?.showContactUsBtn && canShowBuyNow" (click)="onContactSales($event)"
    [trackClick]="{ page: 'Contact Sales Button Clicked', location: trackLocation }">
    {{ contactButtonText | uppercase }}
  </a>

  <!-- Contact Sales when Buy Now is not visible (UAR wants raised) -->
  <a mat-raised-button color="primary" class="learn-more-button upgrade-btn cursor pointer"
    *ngIf="upsellButtons?.showContactUsBtn && !canShowBuyNow && contactRaisedWhenNoBuyNow"
    (click)="onContactSales($event)" [trackClick]="{ page: 'Contact Sales Button Clicked', location: trackLocation }">
    {{ contactButtonText }}
  </a>

  <!-- Upgrade -->
  <button mat-raised-button color="primary" class="learn-more-button upgrade-btn"
    *ngIf="showUpgradeBtn && canUpgrade && upgradeUrl" (click)="onUpgrade($event)" [disabled]="effectiveLoading"
    [trackClick]="{ page: 'Upgrade Button Clicked', location: trackLocation }">
    <mat-spinner *ngIf="effectiveLoading" diameter="16" class="button-spinner"></mat-spinner>
    <span class="btn-label" [class.invisible]="effectiveLoading">{{ upgradeButtonText | uppercase }}</span>
  </button>

  <!-- Buy Now -->
  <button mat-raised-button color="primary" class="learn-more-button upgrade-btn" *ngIf="canShowBuyNow && enableBuyNow"
    (click)="openBuyConfirm($event)" [disabled]="effectiveLoading"
    [trackClick]="{ page: 'Buy Now Button Clicked', location: trackLocation }">
    <mat-spinner *ngIf="effectiveLoading" diameter="16" class="button-spinner"></mat-spinner>
    <span class="btn-label" [class.invisible]="effectiveLoading">{{ getBuyNowButtonLabel() }}</span>
  </button>
</div>

<!-- Shared Buy Confirm Dialog -->
<app-upsell-buy-confirm *ngIf="showBuyConfirm" [loading]="effectiveLoading" [showActivationLine]="showActivationLine"
  [chargeText]="dialogChargeText" [chargeUnitText]="dialogChargeUnitText" [activationText]="dialogActivationText"
  [confirmLabel]="confirmLabel" [cancelLabel]="cancelLabel" [trackLocation]="trackLocation"
  [trackUrl]="resolvedBuyNowTrackUrl" [enableDiscount]="enableDiscount" [discountCodeValue]="discountCodeValue"
  [appliedDiscount]="appliedDiscount" [validatingDiscount]="validatingDiscount"
  [discountValidationError]="discountValidationError" [showingDiscountInput]="showingDiscountInput"
  [originalPrice]="getOriginalPrice()" [discountedPrice]="getDiscountedPrice()"
  [formattedPrice]="getFormattedPriceForConfirmation()" [confirmationTextPrefix]="getConfirmationTextPrefix()"
  [confirmationTextSuffix]="getConfirmationTextSuffix()" (confirm)="confirmBuyNow()" (cancel)="cancelBuyConfirm()"
  (applyDiscount)="applyDiscountCode()" (clearDiscount)="clearDiscount()" (showDiscountInput)="showDiscountInput()"
  (discountCodeChange)="onDiscountCodeChange($event)"
  (discountKeyPress)="onDiscountCodeKeyPress($event)"></app-upsell-buy-confirm>

<!-- Payment Failed Dialog (same overlay position as confirm) -->
<app-upsell-payment-failed *ngIf="showPaymentFailed" [show]="true" [loading]="paymentRetryLoading"
  [trackLocation]="trackLocation" [trackUrl]="resolvedBuyNowTrackUrl" (retry)="onPaymentRetry()"
  (updatePaymentMethod)="onPaymentUpdatePaymentMethod()" (dismiss)="onPaymentDismiss()"></app-upsell-payment-failed>

<!-- Small company layout (Learn More on left, Buy Now on right) -->
<div class="bottom-buttons small-company" *ngIf="isSmallCompany || billingMode === 'invoicing'">
  <!-- Learn More (left) -->
  <a mat-stroked-button color="primary" class="learn-more-button" [href]="learnMoreUrl" target="_blank" rel="noopener"
    [trackClick]="{ page: 'Learn More Button Clicked', location: trackLocation }">
    {{ learnMoreLabel | uppercase }}
  </a>

  <!-- Buy Now (right) -->
  <button mat-raised-button color="primary" class="learn-more-button upgrade-btn" *ngIf="canShowBuyNow && enableBuyNow"
    (click)="openBuyConfirm($event)" [disabled]="effectiveLoading"
    [trackClick]="{ page: 'Buy Now Button Clicked', location: trackLocation }">
    <mat-spinner *ngIf="effectiveLoading" diameter="16" class="button-spinner"></mat-spinner>
    <span class="btn-label" [class.invisible]="effectiveLoading">{{ getBuyNowButtonLabel() }}</span>
  </button>

  <!-- Upgrade (right) -->
  <button mat-raised-button color="primary" class="learn-more-button upgrade-btn"
    *ngIf="showUpgradeBtn && canUpgrade && upgradeUrl" (click)="onUpgrade($event)" [disabled]="effectiveLoading"
    [trackClick]="{ page: 'Upgrade Button Clicked', location: trackLocation }">
    <mat-spinner *ngIf="effectiveLoading" diameter="16" class="button-spinner"></mat-spinner>
    <span class="btn-label" [class.invisible]="effectiveLoading">{{ upgradeButtonText | uppercase }}</span>
  </button>

  <!-- Contact Sales when invoicing -->
  <a mat-raised-button color="primary" class="learn-more-button" *ngIf="billingMode === 'invoicing'"
    (click)="onContactSales($event)" [trackClick]="{ page: 'Contact Sales Button Clicked', location: trackLocation }">
    {{ contactButtonText | uppercase }}
  </a>
</div>
